import { Image, ImageJson } from './types';

export function jsonToImage(imageJson: ImageJson): Image {
  return {
    ...imageJson,
    created: new Date(imageJson.created),
    updated: new Date(imageJson.updated),
  };
}
